<template>
    <div class="container">
        <div class="card purple darken-1">
          <div class="card-content white-text">
            <span class="card-title">Track your shape</span>
            <p>Aloha {{ name }}, remind to track regularly your amazing body shape.</p>
          </div>
          <div class="card-action">
            <router-link :to="{ name: 'Athlete', params: {tab:'body'}}">
              <span v-on="call('trackBody')"><i class="material-icons">person</i> Go to Athlete profile</span>
            </router-link>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'trackBodyRemind',
  props: {
    'name': String,
    'callback': Function
  },
  methods: {
    call: function (card) {
      if (this.callback) this.callback(card)
    }
  }

}
</script>


// WEBPACK FOOTER //
// src/components/cards/TrackBodyRemind.vue